import React, { useEffect, useState, useRef } from "react";
import "./dataIntegration.css";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoMdClose } from 'react-icons/io';
import { FaChartBar } from "react-icons/fa";
import { FaTableCells } from "react-icons/fa6";
import { LuRefreshCw } from "react-icons/lu";
import { MdAttachment } from "react-icons/md";
import { FaExpand, FaCompress } from "react-icons/fa";
import { MdCloudUpload } from "react-icons/md";
import { fetchisgsEnt, commitDAEnt, fetchippsEnt, fetchDamClearingPrice, fetchRtmClearingPrice, fetchGdamClearingPrice, fetchIsgsCurrentSchedule, commitISGSDC, commitinternaldc } from "./api";
import { MdOutlineRefresh } from "react-icons/md";
import Table from "./table";
import Charts from "./charts";
import * as d3 from "d3";
import StackedBarCharts from "./stackedBarCharts";

const DataIntegration = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [selectedOption, setSelectedOption] = useState("Market Data");
    const [selectedMapOption, setSelectedMapOption] = useState("");
    const [filteredMapOptions, setFilteredMapOptions] = useState([]);
    const dropdownRef = useRef(null);
    const getTodayInIST = () => {
        const now = new Date();

        const istOffset = 5.5 * 60 * 60 * 1000;
        const istDate = new Date(now.getTime() + istOffset);

        return istDate.toISOString().split("T")[0];
    };

    const getTomorrowInIST = () => {
        const now = new Date();

        const istOffset = 5.5 * 60 * 60 * 1000;
        const istDate = new Date(now.getTime() + istOffset);

        istDate.setDate(istDate.getDate() + 1);
        return istDate.toISOString().split("T")[0];
    };
    const [selectedDate, setSelectedDate] = useState(getTomorrowInIST());
    const [dragOver, setDragOver] = useState(false);
    const options = ["Market Data", "ISGS-Gen", "IPPS-Gen", "Re-Gen", "Weather Data"];
    const [files, setFiles] = useState([]);
    const mapOptionsData = {
        "Market Data": ["Day-ahead", "RTM", "GDAM"],
        "ISGS-Gen": ["Current Schedule", "Current summary", "Day-ahead Entitlement"],
        "IPPS-Gen": ["Day-ahead Entitlement"],
        //  "Internal-gen": ["Current Schedule", "Day-ahead Entitlement"],
        "Re-Gen": ["Day-ahead", "Real-time"],
        "Weather Data": ["Weather Data"],
    };
    const [fileUploaded, setFileUploaded] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedFileIndex, setSelectedFileIndex] = useState(null);
    const [showTable, setShowTable] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const marketBarRef = useRef(null);
    const [headers, setHeaders] = useState([]);
    const [tableData, setTableData] = useState([]);
    const tableRef = useRef(null);
    const chartRef = useRef(null);
    const [xData, setXData] = useState([]);
    const [yData, setYData] = useState([]);
    const [statusMessage, setStatusMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setFilteredMapOptions(mapOptionsData[selectedOption] || []);
        setSelectedMapOption(mapOptionsData[selectedOption]?.[0] || "");
    }, [selectedOption]);

    useEffect(() => {
        if (statusMessage) {
            const timer = setTimeout(() => {
                setStatusMessage('');
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [statusMessage]);

    useEffect(() => {
        if (!selectedOption) return;

        const mapOptions = mapOptionsData[selectedOption];
        if (mapOptions && mapOptions.length > 0) {
            setSelectedMapOption(mapOptions[0]);
            setFilteredMapOptions(mapOptions);
        } else {
            setSelectedMapOption("");
            setFilteredMapOptions([]);
        }
    }, [selectedOption]);


    useEffect(() => {
        if (!selectedOption || !selectedMapOption || !selectedDate) return;

        if (selectedOption === "Market Data") {
            fetchData();
        } else if (selectedOption === "ISGS-Gen") {
            handleFetchData();
        } else if (selectedOption === "IPPS-Gen") {
            handleFetchDataIPPS();
        }
    }, [selectedOption, selectedMapOption, selectedDate]);


    const handleSelect = (option, type) => {
        if (type === "market") {
            setSelectedOption(option);
            setHeaders([]);
            setTableData([]);
            setXData([]);
            setYData([]);
        } else {
            setSelectedMapOption(option);
            setHeaders([]);
            setTableData([]);
            setXData([]);
            setYData([]);
        }

        setOpenDropdown(null);
    };

    const toggleDropdown = (type) => {
        setOpenDropdown(openDropdown === type ? null : type);
    };

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            marketBarRef.current?.requestFullscreen();
            setIsFullscreen(true);
        } else {
            document.exitFullscreen();
            setIsFullscreen(false);
        }
    };

    useEffect(() => {
        const handleExitFullscreen = () => {
            if (!document.fullscreenElement) {
                setIsFullscreen(false);
            }
        };

        document.addEventListener("fullscreenchange", handleExitFullscreen);
        return () => {
            document.removeEventListener("fullscreenchange", handleExitFullscreen);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => {
        setDragOver(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragOver(false);
        const droppedFiles = event.dataTransfer.files;
        handleFileUpload(droppedFiles);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => {
            const updatedFiles = prevFiles.filter((_, i) => i !== index);
            if (updatedFiles.length === 0) {
                // setHeaders([]);
                // setTableData([]);
                // setCsvData([]);
                // setXData([]);
                // setYData([]);
                setFileUploaded(false);
            } else {
                // processFiles(updatedFiles);
            }
            return updatedFiles;
        });
    };

    const handleFileUpload = (newFiles) => {
        const csvFiles = Array.from(newFiles).filter(file => file.name.endsWith('.csv') && file.size <= 15 * 1024 * 1024);
        const invalidFiles = Array.from(newFiles).filter(file => !file.name.endsWith('.csv'));
        const oversizedFiles = Array.from(newFiles).filter(file => file.size > 15 * 1024 * 1024);

        if (invalidFiles.length > 0) {
            setErrorMessage("Invalid file type. Please upload only .csv files.");
            setTimeout(() => setErrorMessage(""), 3000);
        }

        if (oversizedFiles.length > 0) {
            setErrorMessage("File size exceeds 15MB limit. Please upload files within the size limit.");
            setTimeout(() => setErrorMessage(""), 3000);
        }

        if (csvFiles.length > 0) {
            setFileUploaded(true);
            setFiles((prevFiles) => {
                const combinedFiles = [...prevFiles, ...csvFiles];
                return combinedFiles;
            });
        }
    };

    const handleFetchData = async () => {
        setLoading(true);

        try {
            if (selectedOption === "ISGS-Gen" && selectedMapOption === "Day-ahead Entitlement") {
                try {
                    setHeaders([]);
                    setTableData([]);
                    setXData([]);
                    setYData([]);
                    const response = await fetchisgsEnt(selectedDate);
                    const jsonData = response;
                    processJsonData(jsonData);
                } catch (error) {
                    // console.error("Error fetching ISGS ENT data:", error);
                }
            } else {
                // console.error("Conditions not met. API not called.");
            }

            if (selectedOption === "ISGS-Gen" && selectedMapOption === "Current Schedule") {
                try {
                    setHeaders([]);
                    setTableData([]);
                    setXData([]);
                    setYData([]);
                    const response = await fetchIsgsCurrentSchedule(selectedDate);
                    const jsonData = response;
                    processJsonData(jsonData);
                } catch (error) {
                    //  console.error("Error fetching ISGS ENT data:", error);
                }
            } else {
                // console.error("Conditions not met. API not called.");
            }
        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFetchDataIPPS = async () => {
        setLoading(true);

        try {
            if (selectedOption === "IPPS-Gen" && selectedMapOption === "Day-ahead Entitlement") {
                try {
                    setHeaders([]);
                    setTableData([]);
                    setXData([]);
                    setYData([]);
                    const response = await fetchippsEnt(selectedDate);
                    const jsonData = response;

                    processJsonData(jsonData);
                } catch (error) {
                    //  console.error("Error fetching ISGS ENT data:", error);
                }
            } else {
                //  console.error("Conditions not met. API not called.");
            }
        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const processMarketJsonData = (response) => {
        const data = response.data;
        if (!Array.isArray(data) || data.length === 0) {
            //   console.error("Invalid or empty data format");
            return;
        }

        const processedData = [];
        const columnDataTypes = {};
        const nonEditableColumns = new Set();
        const columnsWithNull = new Set();
        const uniqueHeaders = new Set();

        const formatDate = (dateStr) => {
            const date = new Date(dateStr);
            if (isNaN(date)) return dateStr;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}/${month}/${day}`;
        };

        data.forEach((row) => {
            const newRow = {};

            Object.entries(row).forEach(([key, value]) => {
                let finalValue = value;

                uniqueHeaders.add(key);

                if (value === null) {
                    finalValue = "null";
                    columnsWithNull.add(key);
                    columnDataTypes[key] = columnDataTypes[key] || "string";
                } else if (typeof value === "boolean") {
                    columnDataTypes[key] = "boolean";
                } else if (!isNaN(value) && value !== "") {
                    finalValue = value;
                    columnDataTypes[key] = columnDataTypes[key] || "number";
                } else if (!isNaN(Date.parse(value))) {
                    finalValue = formatDate(value);
                    columnDataTypes[key] = columnDataTypes[key] || "date";
                } else {
                    columnDataTypes[key] = columnDataTypes[key] || "string";
                }

                newRow[key] = finalValue;

                if (["block_no"].includes(key.toLowerCase())) {
                    nonEditableColumns.add(key);
                }
            });

            processedData.push(newRow);
        });

        processedData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });

        const headersWithMetadata = Array.from(uniqueHeaders)
            .sort((a, b) => {
                if (a.toLowerCase() === "id") return -1;
                if (b.toLowerCase() === "id") return 1;
                if (nonEditableColumns.has(a) && !nonEditableColumns.has(b)) return -1;
                if (!nonEditableColumns.has(a) && nonEditableColumns.has(b)) return 1;
                return 0;
            })
            .map((key) => ({
                name: key,
                dataType: columnDataTypes[key] || "string",
                editable: !nonEditableColumns.has(key),
                width: 150,
                displayName: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
            }));

        setHeaders(headersWithMetadata);
        setTableData(processedData);
        const fieldNames = headersWithMetadata.map(h => h.name);
        prepareChartData(processedData, fieldNames);
    };

    const processJsonData = (response) => {
        const data = response.data;
        if (!Array.isArray(data) || data.length === 0) {
            //  console.error("Invalid or empty data format");
            return;
        }

        const unitNames = new Set();
        data.forEach(row => {
            if (row.unit_name) unitNames.add(row.unit_name);
        });

        const groupedMap = new Map();

        data.forEach(row => {
            const key = `${row.date}|${row.block_no}|${row.rev_no}`;
            if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                    date: row.date,
                    block_no: row.block_no,
                    rev_no: row.rev_no,
                });
            }
            const currentRow = groupedMap.get(key);

            const valueField = data[0].hasOwnProperty('schedule') ? 'schedule' : 'entitlement';

            currentRow[row.unit_name] = parseFloat(row[valueField]);

        });

        const processedData = Array.from(groupedMap.values());
        processedData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });
        const headersWithMetadata = [
            {
                name: "date",
                dataType: "date",
                editable: false,
                width: 150,
                displayName: "Date",
            },
            {
                name: "block_no",
                dataType: "number",
                editable: false,
                width: 100,
                displayName: "Block No",
            },
            {
                name: "rev_no",
                dataType: "number",
                editable: false,
                width: 100,
                displayName: "Rev No",
            },
            ...Array.from(unitNames).map(unit => ({
                name: unit,
                dataType: "number",
                editable: true,
                width: 120,
                displayName: unit,
            })),
        ];

        setHeaders(headersWithMetadata);
        setTableData(processedData);
        const fieldNames = headersWithMetadata.map(h => h.name);
        prepareChartData(processedData, fieldNames);
    };

    const prepareChartData = (data, fields) => {
        if (data.length > 0 && fields.length > 2) {
            const generateTimeSlots = (blocks) => {
                return Array.from({ length: blocks }, (_, i) => {
                    const hours = String(Math.floor(i / 4)).padStart(2, "0");
                    const minutes = String((i % 4) * 15).padStart(2, "0");
                    return `${hours}:${minutes}`;
                });
            };

            const timeSlots = generateTimeSlots(96);
            const xValues = data.map(row => timeSlots[row["block_no"] - 1]);

            const numericFields = fields.filter(
                (field) => field !== "Date" && field !== "block_no" && data.some(row => !isNaN(parseFloat(row[field])) && isFinite(row[field]))
            );

            const yValues = numericFields.map((field, index) => ({
                field,
                values: data.map(row => parseFloat(row[field]) || 0),
                color: d3.schemeCategory10[index % 10],
            }));

            setXData(xValues);
            setYData(yValues);
        }
    };

    const handleCommit = async () => {
        setLoading(true);

        try {
            const updatedTableData = tableRef.current?.getUpdatedData();
            const editedTableData = formatTableDataForAPI(updatedTableData, headers, " ");
            const apiRequestBody = formatTableDataForAPI(tableData, headers, " ");

            try {
                if (selectedOption === "ISGS-Gen" && selectedMapOption === "Day-ahead Entitlement") {
                    editedTableData.forEach(row => row.unshift("ISGS"));

                    const [entRes, dcRes] = await Promise.all([
                        commitDAEnt(editedTableData),
                        commitISGSDC(apiRequestBody)
                    ]);

                    if (entRes.status === 200 && dcRes.status === 200) {
                        setStatusMessage("Data committed successfully!");
                        setMessageType('success');
                    } else {
                        setStatusMessage("One or both API calls failed.");
                        setMessageType('error');
                    }

                } else if (selectedOption === "IPPS-Gen" && selectedMapOption === "Day-ahead Entitlement") {
                    editedTableData.forEach(row => row.unshift("INTERNAL"));

                    const [entRes, dcRes] = await Promise.all([
                        commitDAEnt(editedTableData),
                        commitinternaldc(apiRequestBody)
                    ]);

                    if (entRes.status === 200 && dcRes.status === 200) {
                        setStatusMessage("Data committed successfully!");
                        setMessageType('success');
                    } else {
                        setStatusMessage("One or both API calls failed.");
                        setMessageType('error');
                    }
                }
            } catch (err) {
                setStatusMessage("API call failed.");
                setMessageType('error');
            }
        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const formatTableDataForAPI = (tableData, headers, fileName = "") => {
        const excludedHeaders = [
            "region", "state", "discom", "pool", "date", "buyer",
            "block_no", "rev_no", "Grand Total", "Total",
            "Time Block", "Time Desc", "Time"
        ];

        const unitNameHeaders = headers
            .map(header => header.name)
            .filter(header => !excludedHeaders.includes(header));

        const formattedData = [];

        if (!fileName || typeof fileName !== "string") {
            // console.warn("Invalid fileName provided.");
        }

        let extractedDate = null;
        const datePatterns = [
            /(\d{4}-\d{2}-\d{2})$/,
            /(\d{2}-\d{2}-\d{4})$/,
            /(\d{4}-\d{2}-\d{2})/,
            /(\d{2}-\d{2}-\d{4})/
        ];

        for (let pattern of datePatterns) {
            const match = fileName.match(pattern);
            if (match) {
                extractedDate = match[1];
                break;
            }
        }

        if (!extractedDate) {
            //  console.warn("No valid date found in the file name. Keeping extractedDate as null.");
        }

        tableData.forEach(row => {
            unitNameHeaders.forEach(unit_name => {
                if (row[unit_name] !== undefined && row[unit_name] !== "") {
                    let revNo = row.rev_no !== undefined ? parseFloat(row.rev_no) : 1;
                    let blockNo = row.block_no !== undefined ? parseFloat(row.block_no) :
                        (row["Time Block"] ? parseFloat(row["Time Block"]) : null);

                    if (blockNo === null) return;

                    let formattedDate = row.date && row.date.includes("-") ? row.date : extractedDate;

                    if (formattedDate) {
                        const parts = formattedDate.split("-");
                        // If it's in DD-MM-YYYY, convert to YYYY-MM-DD
                        if (parts[0].length === 2 && parts[2].length === 4) {
                            formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else if (parts[0].length !== 4) {
                            //  console.warn(`Unrecognized date format: ${formattedDate}`);
                            formattedDate = "Invalid Date";
                        }
                    } else {
                        //console.warn("Date is missing and could not be extracted from the file name.");
                        formattedDate = "Invalid Date";
                    }

                    formattedData.push([
                        revNo,
                        formattedDate,
                        blockNo,
                        unit_name,
                        parseFloat(row[unit_name])
                    ]);
                }
            });
        });

        return formattedData;
    };

    const fetchData = async () => {
        setLoading(true);

        try {
            if (selectedOption !== "Market Data") {
                // console.error("Not in Market Data section.");
                return;
            }

            try {
                let response;
                setHeaders([]);
                setTableData([]);
                setXData([]);
                setYData([]);
                switch (selectedMapOption) {
                    case "Day-ahead":
                        response = await fetchDamClearingPrice(selectedDate);
                        break;
                    case "RTM":
                        response = await fetchRtmClearingPrice(selectedDate);
                        break;
                    case "GDAM":
                        response = await fetchGdamClearingPrice(selectedDate);
                        break;
                    default:
                        // console.warn("Invalid market option selected.");
                        return;
                }

                if (response) {
                    processMarketJsonData(response);
                }
            } catch (error) {
                //  console.error("Error fetching market data:", error);
            }
        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="positionmap-container" ref={dropdownRef}>
            {loading && (
                <div className="dashboard-loading-bar"></div>
            )}
            <div className="top-bar">
                <div className="date-picker">
                    <input
                        id="date-input"
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        placeholder=" "
                    />
                    <label htmlFor="date-input">Date</label>
                </div>

                {/* Market Dropdown */}
                <div className="dropdown-container">
                    <button onClick={() => toggleDropdown("market")} className="dropdown-button">
                        {selectedOption} {openDropdown === "market" ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </button>

                    {openDropdown === "market" && (
                        <div className="dropdown-menus">
                            {options.map((option, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleSelect(option, "market")}
                                    className={`dropdown-item ${selectedOption === option ? "selected" : ""}`}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Map Dropdown */}
                <div className="dropdown-container">
                    <button onClick={() => toggleDropdown("map")} className="dropdown-button">
                        {selectedMapOption || "Select Map Option"} {openDropdown === "map" ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </button>

                    {openDropdown === "map" && (
                        <div className="dropdown-menus">
                            {filteredMapOptions.map((option, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleSelect(option, "map")}
                                    className={`dropdown-item ${selectedMapOption === option ? "selected" : ""}`}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {statusMessage && (
                <div className={`status-message ${messageType}`}>
                    {statusMessage}
                </div>
            )}

            {/* Data Bar - Dynamic Content */}
            <div className="content-bar">
                {selectedOption === "Market Data" && (
                    <div className={`market-bar ${isFullscreen ? "fullscreen" : ""}`} ref={marketBarRef}>
                        <div className="left-section">
                            <span onClick={() => setShowTable(!showTable)} className="toggle-view">
                                {showTable ? <FaChartBar size={24} /> : <FaTableCells size={24} />}
                            </span>
                            <div className="date-picker">
                                <input
                                    id="date-input"
                                    type="date"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    placeholder=" "
                                    readOnly
                                />
                                <label htmlFor="date-input">For Date</label>
                            </div>
                            <button className="data-market-button" onClick={fetchData}>
                                <MdOutlineRefresh size={24} />
                            </button>
                        </div>
                    </div>
                )}

                {selectedOption === "ISGS-Gen" && (
                    <div className={`market-bar ${isFullscreen ? "fullscreen" : ""}`} ref={marketBarRef}>
                        <div className="left-section">
                            <span onClick={() => setShowTable(!showTable)} className="toggle-view">
                                {showTable ? <FaChartBar size={24} /> : <FaTableCells size={24} />}
                            </span>
                            <div className="date-picker">
                                <input
                                    id="date-input"
                                    type="date"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    placeholder=" "
                                    readOnly
                                />
                                <label htmlFor="date-input">For Date</label>
                            </div>
                            <button className="data-market-button" onClick={handleFetchData}>
                                <MdOutlineRefresh size={24} />
                            </button>
                            {["Current Schedule", "Day-ahead Entitlement"].includes(selectedMapOption) && (
                                <button className="data-market-button" onClick={handleCommit}>
                                    <MdCloudUpload size={24} />
                                </button>
                            )}
                        </div>
                    </div>
                )}

                {selectedOption === "IPPS-Gen" && (
                    <div className={`market-bar ${isFullscreen ? "fullscreen" : ""}`} ref={marketBarRef}>
                        <div className="left-section">
                            <span onClick={() => setShowTable(!showTable)} className="toggle-view">
                                {showTable ? <FaChartBar size={24} /> : <FaTableCells size={24} />}
                            </span>
                            <div className="date-picker">
                                <input
                                    id="date-input"
                                    type="date"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    placeholder=" "
                                    readOnly
                                />
                                <label htmlFor="date-input">For Date</label>
                            </div>
                            <button className="data-market-button" onClick={handleFetchDataIPPS}>
                                <MdOutlineRefresh size={24} />
                            </button>
                            {["Current Schedule", "Day-ahead Entitlement"].includes(selectedMapOption) && (
                                <button className="data-market-button" onClick={handleCommit}>
                                    <MdCloudUpload size={24} />
                                </button>
                            )}
                        </div>
                    </div>
                )}

                {selectedOption === "Internal-gen" && (
                    <div>
                        {selectedMapOption === "Current Schedule" && (
                            <p>Day-ahead live schedule goes here</p>
                        )}

                        {selectedMapOption === "Day-ahead Entitlement" && (
                            <div>
                                <div
                                    className={`dropzones ${dragOver ? 'drag-over' : ''}`}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                >
                                    <p>Drag and drop your files here</p>
                                    <p className="limit-text">Limit 15MB per file. Supported files: .CSV</p>
                                    <input
                                        type="file"
                                        accept=".csv"
                                        multiple
                                        onChange={(e) => handleFileUpload(e.target.files)}
                                        className="file-input"
                                    />
                                    <button className="browse-button" onClick={() => document.querySelector('.file-input').click()}>
                                        Browse Files
                                    </button>

                                    <ul className="file-list">
                                        {files.map((file, index) => (
                                            <li key={index} className="file-item" onClick={() => setSelectedFileIndex(index)}>
                                                <span className="file-name">{file.name}</span>
                                                <IoMdClose className="remove-icon" onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleRemoveFile(index);
                                                }} />
                                            </li>
                                        ))}
                                    </ul>

                                    {files.length > 0 && <p className="file-count">{files.length} file(s) selected</p>}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {selectedOption === "Re-Gen" && (
                    <div className={`market-bar ${isFullscreen ? "fullscreen" : ""}`} ref={marketBarRef}>
                        <div className="left-section">
                            <span onClick={() => setShowTable(!showTable)} className="toggle-view">
                                {showTable ? <FaChartBar size={24} /> : <FaTableCells size={24} />}
                            </span>
                            <div className="date-picker">
                                <input
                                    id="date-input"
                                    type="date"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    placeholder=" "
                                    readOnly
                                />
                                <label htmlFor="date-input">For Date</label>
                            </div>
                            <button className="data-market-button">
                                <MdOutlineRefresh size={24} />
                            </button>
                            {["Day-ahead"].includes(selectedMapOption) && (
                                <button className="data-market-button">
                                    <MdCloudUpload size={24} />
                                </button>
                            )}
                        </div>
                    </div>
                )}
                {selectedOption === "Weather Data" && (
                    <div>
                        <div className="left-section">
                            <button className="market-button">
                                FETCH ACTUAL WEATHER
                            </button>
                        </div>
                        <br></br>
                        <div className="left-section">
                            <button className="market-button">
                                FETCH WEATHER FORECASTE
                            </button>
                        </div>
                    </div>
                )}
                {showTable ? (
                    tableData.length > 0 && (
                        <Table
                            ref={tableRef}
                            headers={headers}
                             maxHeight="550px"
                            rows={tableData}
                            edit={true}
                            sorting={true}
                            drag={true}
                            filtering={true}
                            exporting={true}
                            addRow={false}
                            restrictEditToNewRows={false}
                        />
                    )
                ) : xData.length > 0 && yData.length > 0 ? (
                    selectedOption === "ISGS-Gen" || selectedOption === "IPPS-Gen" ? (
                        <StackedBarCharts
                            ref={chartRef}
                            xData={xData}
                            yData={yData}
                            drag={true}
                            edit={true}
                        />
                    ) : (
                        <Charts
                            ref={chartRef}
                            xData={xData}
                            yData={yData}
                            drag={true}
                            edit={true}
                        />
                    )
                ) : null}
            </div>
        </div>
    );
};

export default DataIntegration;